export const selectIdNumber = state => state.idNumber.data;
